
import { Outlet } from "react-router-dom";
import Assessment_attributes from "./assessment_attributes";
import TopNavbar from "../components/TopNavbar";

const Assessment = ( ) => {
 
  
    return (
        <div>
    <TopNavbar />
    <Assessment_attributes />   

     <Outlet/>      
    </div>
  );
};
 
export default Assessment;